<template lang="pug">
            el-row
                el-col( :span="8")
                        el-select(:disabled='disabled',v-model='baseForm.cityId', placeholder='请选择市', size='mini', style='width:100%;margin:0 10px 0 0', filterable='', @click.native='selectHuShi()', @change='hushiValue')
                            el-option(v-for='item in option4', :label='item.addressName', :key='item.id', :value='item.id')

                el-col( :span="8")
                        el-select(:disabled='disabled',v-model='baseForm.areaId', placeholder='请选择区', size='mini', style='width:100%;margin:0 10px 0 0', filterable='', @click.native='selectHuQu()', @change='huquValue')
                            el-option(v-for='item in option5', :label='item.addressName', :key='item.id', :value='item.id')

                el-col( :span="8")
                        el-select(:disabled='disabled',v-model='baseForm.streetId', placeholder='请选择街道', size='mini', style='width:100%;margin:0 10px 0 0', filterable='', @click.native='selectHujd()', @change='hujdValue')
                            el-option(v-for='item in option6', :label='item.addressName', :key='item.id', :value='item.id')

                el-col( :span="24")
                        el-input(:disabled='disabled', @blur='transLocation',  v-model='baseForm.addressDetail', placeholder='请输入详细地址')
                el-col( :span="24")
                        #mapDome(style='width:100%;height:200px;margin-top:10px') 
</template>

<script>
import { addressMix } from "@/mixins/addressMix.js";
import AMap from "AMap"; // 引入高德地图
import { findAddressByParentId } from "@/api/http";
export default {
    name: "mapLocation",
    props: {
        data: Object,
        onSuccess: Function,
        disabled: {
            default: false
        }
    },
    components: {},
    data() {
        return {
            activityAddress: {},
            baseForm: {},
            option4: [],
            option5: [],
            option6: []
        };
    },
    computed: {},
    methods: {
        debounce(fn, wait) {
            var timer = null;
            return function() {
                var context = this;
                var args = arguments;
                if (timer) {
                    clearTimeout(timer);
                    timer = null;
                }
                timer = setTimeout(function() {
                    fn.apply(context, args);
                }, wait);
            };
        },
        changeLocation(e) {
            //this.debounce(this.debounce(e),1000)
        },
        //根据输入地址转换经纬度并标记
        transLocation(e) {
            this.baseForm.cityLabel = this.baseForm.cityLabel || "";
            this.baseForm.areaLabel = this.baseForm.areaLabel || "";
            this.baseForm.streetLabel = this.baseForm.streetLabel || "";

            //   this.$set(this.baseForm, "addressDetail", e.target.value);
            let searchKey;
            if (e) {
                searchKey =
                    // this.baseForm.cityLabel +
                    // this.baseForm.areaLabel +
                    // this.baseForm.streetLabel +
                    e.target.value;
            } else {
                searchKey = ''
                    // this.baseForm.cityLabel +
                    // this.baseForm.areaLabel +
                    // this.baseForm.streetLabel;
            }

            //   console.log(searchKey);
            const that = this;
            let geocoder = new AMap.Geocoder({
                radius: 1000,
                extensions: "all"
            });

            geocoder.getLocation(searchKey, (status, result) => {
                if (status === "complete" && result.geocodes.length) {
                    let lnglat = result.geocodes[0].location;

                    this.baseForm.longitude = lnglat.lng;
                    this.baseForm.latitude = lnglat.lat;
                    this.setmarkerFunc(lnglat.lng, lnglat.lat);
                } else {
                    this.$message({
                        message: "获取坐标失败，请手动获取",
                        type: "error"
                    });
                    this.baseForm.longitude = "";
                    this.baseForm.latitude = "";
                    //   this.baseForm.addressDetail = "";
                    this.$set(this.baseForm, "addressDetail", "");
                }
            });
            this.onSuccess(this.baseForm);
        },
        setmarkerFunc(longitude, latitude) {
            this.mapmarker.setPosition([longitude, latitude]);

            this.mapcontainer.add(this.mapmarker);
            this.mapcontainer.setFitView(this.mapmarker);
        },
        //初始化地图插件的方法
        mapInit(containerId) {
            this.mapcontainer = new AMap.Map(containerId, {
                resizeEnable: true,
                zoom: 18,
                zooms: [3, 20],
                expandZoomRange: true,
                center: [118.006294,32.779161]
                
            });
            this.mapmarker = new AMap.Marker({
                 position: [116.842064,32.634156],
                map: this.mapcontainer
            });
            if (this.baseForm.longitude && this.baseForm.latitude) {
                this.setmarkerFunc(
                    this.baseForm.longitude,
                    this.baseForm.latitude
                );
                // let marker = new AMap.Marker({
                //   position: [this.baseForm.longitude, this.baseForm.latitude],
                //   map: this.mapcontainer
                // });
                // this.mapcontainer.setFitView(marker);
            } else {
                // AMap.plugin("AMap.Geolocation", () => {
                //   //异步定位当前
                //   let geolocation = new AMap.Geolocation();
                //   console.log(geolocation);

                //   this.mapcontainer.addControl(geolocation);
                // });

                this.mapcontainer.plugin("AMap.Geolocation", () => {
                    this.geolocation = new AMap.Geolocation({
                        enableHighAccuracy: true, //是否使用高精度定位，默认:true
                        timeout: 10000 //超过10秒后停止定位，默认：无穷大
                        // buttonOffset: new AMap.Pixel(10, 20), //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
                        // zoomToAccuracy: false, //定位区域
                        // buttonPosition: "RB"
                    });
                    // this.mapcontainer.addControl(this.geolocation);

                    // this.geolocation.getCurrentPosition();

                    AMap.event.addListener(
                        this.geolocation,
                        "complete",
                        data => {
                            // this.setmarkerFunc(
                            //     data.position.getLng(),
                            //     data.position.getLat()
                            // );
                            // var str = ["定位成功"];
                            // str.push("经度：" + data.position.getLng());
                            // str.push("纬度：" + data.position.getLat());
                            // str.push("精度：" + data.accuracy + " 米");
                            // str.push("是否经过偏移：" + (data.isConverted ? "是" : "否"));
                            // console.log(str);
                        }
                    ); //返回定位信息
                });
            }

            if (this.disabled) {
                return false;
            }
            //定义地图坐标点击事件
            this.mapcontainer.on("click", e => {
                // console.log(e);

                this.baseForm.longitude = e.lnglat.getLng();
                this.baseForm.latitude = e.lnglat.getLat();

                // 这里通过高德 SDK 完成。
                var geocoder = new AMap.Geocoder({
                    radius: 1000,
                    extensions: "all"
                });

                geocoder.getAddress(
                    [this.baseForm.longitude, this.baseForm.latitude],
                    (status, result) => {
                        if (status === "complete" && result.info === "OK") {
                            if (result && result.regeocode) {
                                // this.baseForm.addressDetail = result.regeocode.formattedAddress;
                                this.$set(
                                    this.baseForm,
                                    "addressDetail",
                                    result.regeocode.formattedAddress
                                );
                                this.onSuccess(this.baseForm);
                            }
                        }
                    }
                );
                this.setmarkerFunc(
                    this.baseForm.longitude,
                    this.baseForm.latitude
                );
            });
        },
        async selectHuShi() {
            this.option4 = [];
            let res = await findAddressByParentId({
                id: 1
            });
            this.option4 = this.option4.concat(res.content.list);
        },
        hushiValue(value) {
            this.hushiId = value;
            this.baseForm.cityId = value;

            let obj = {};
            obj = this.option4.find(item => {
                //这里的ClaOptions就是上面遍历的数据源
                return item.id === value; //筛选出匹配数据，这里的value是你遍历数组每一项的value，如果没有对后台返回的数据做处理，一般为id
            });
            this.baseForm.cityLabel = obj.addressName;
        },
        async selectHuQu() {
            this.option5 = [];
            let res = await findAddressByParentId({
                id: this.hushiId || this.baseForm.cityId
            });
            this.option5 = this.option5.concat(res.content.list);
        },
        huquValue(value) {
            this.huquId = value;
            this.baseForm.areaId = value;
            let obj = {};
            obj = this.option5.find(item => {
                //这里的ClaOptions就是上面遍历的数据源
                return item.id === value; //筛选出匹配数据，这里的value是你遍历数组每一项的value，如果没有对后台返回的数据做处理，一般为id
            });
            this.baseForm.areaLabel = obj.addressName;
        },
        async selectHujd() {
            this.option6 = [];
            let res = await findAddressByParentId({
                id: this.huquId || this.baseForm.areaId
            });
            this.option6 = this.option6.concat(res.content.list);
        },
        hujdValue(value) {
            this.hujdId = value;
            this.baseForm.streetId = value;
            let obj = {};
            obj = this.option6.find(item => {
                //这里的ClaOptions就是上面遍历的数据源
                return item.id === value; //筛选出匹配数据，这里的value是你遍历数组每一项的value，如果没有对后台返回的数据做处理，一般为id
            });
            this.baseForm.streetLabel = obj.addressName;
            // this.transLocation();
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.mapInit("mapDome");
        });
    },
    created() {
        if (this.data) {
            this.baseForm = this.data;
            this.$nextTick(res => {
                this.selectHuShi();
                this.selectHuQu();
                this.selectHujd();
            });
        }
    },
    watch: {}
};
</script>
<style lang="less" >
.peopleServiceBaseForm {
    .dialog-footer {
        text-align: center;
    }
    .step_box {
        margin-bottom: 20px;
    }
    .step2 {
        .el-step__title {
            color: #999;
        }
    }
    .step1Done {
        .el-step__title {
            //   color: #67c23a;
        }
    }
}
</style>